import { getContent } from '../core/store.js';
import { getDomElements } from '../utils/dom.js';

export function renderSupportPage() {
    const content = getContent();
    const domRefs = getDomElements();

    if (!domRefs.pageContent || !content) return;

    // Find support content
    const supportContent = content.find(item => item.name === "support");
    if (!supportContent) {
        domRefs.pageContent.innerHTML = `
            <h1>Customer Support</h1>
            <p>Support details are not available.</p>
        `;
        return;
    }

    // Get content details
    const title = supportContent.details.find(detail => detail.name === "title")?.value || "Customer Support";
    const contactEmail = supportContent.details.find(detail => detail.name === "contact_email")?.value || "";

    // Build HTML
    let html = `
        <h1>${title}</h1>
    `;

    // Contact support section
    if (contactEmail) {
        html += `
            <section class="support-section">
                <h2>Contact Us</h2>
                
                <p>Our customer support team is here to help you with any questions or issues you may have.</p>
                
                <div class="contact-method">
                    <i class="fas fa-envelope"></i>
                     <p>${contactEmail}</p>
                </div>
            </section>
        `;
    }

    // Update page content
    domRefs.pageContent.innerHTML = html;
    document.title = "Support";
}